<template>
   <el-tabs type="border-card">
    <el-tab-pane label="友链列表">
      <div style="margin-top:16px;" >
        <el-form :inline="true" :model="skipForm" class="demo-form-inline">
          <el-form-item label="友链名称">
            <el-input size="mini" v-model.trim="skipForm.name" placeholder="友链名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="onSubmit" icon="el-icon-search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="primary" size="mini" @click="onAdd" icon="el-icon-circle-plus-outline">新增</el-button>
      </div>
      <div style="margin-top:10px;">
        <el-table
        size = "small"
          :data="data"
          border>
          <el-table-column
            prop="id"
            label="ID编号"
            width="100">
          </el-table-column>
          <el-table-column
            prop="name"
            width="260"
            show-overflow-tooltip
            label="友链名称">
          </el-table-column>
          <el-table-column
            prop="url"
            show-overflow-tooltip
            label="友链链接">
          </el-table-column>
          <el-table-column
            width="240"
            prop="createDate"
            label="创建时间">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.row)">编辑</el-button>
              <el-popconfirm
                @confirm="handleDelete(scope.row, scope.$index)"
                title="确定删除这条记录吗？">
                <el-button slot="reference"
                type="danger"
                size="mini">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination :pagination="pagination" v-on:paginationClick="queryPagination"></pagination>
    </el-tab-pane>
   </el-tabs>
</template>
<script>
import pagination from "../../common/util/pagination";
export default {
  data() {
    return {
      data: [],
      skipForm: {
        name: '',
        token: this.user.getToken()
      },
      pagination: {
        pageSize: 10,
        pageNum: 1,
        pageTotal: 0
      }
    };
  },
  components: {
    pagination
  },
  mounted: function() {
    this.getAritcleList()
  },
  methods: {
    getAritcleList: function() {
      this.optionItem = this.common.extend(this.skipForm, this.pagination)
      // 初始化默认加载菜单
      this.http.post(
        '/skip/list',
        this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.data = res.datas.data
            this.pagination.pageSize = res.datas.page.pageSize
            this.pagination.pageNum = res.datas.page.pageNum
            this.pagination.pageTotal = res.datas.page.pageCount
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    },
    onSubmit: function() {
      this.pagination.pageNum = 1
      this.getAritcleList()
    },
    queryPagination: function(currPage) {
      this.pagination.pageNum = currPage
      this.getAritcleList()
    },
    onAdd: function() {
      this.$router.push("/skip/add")
    },
    handleEdit: function(row) {
      this.$router.push({name:'skipEditor',params:row})
    }, 
    handleDelete: function(row, index) {
      this.http.post(
        '/skip/delete',
        row, res => {
          if (res.success) {
            // 返回正确的处理
            this.$router.push("/skip/list")
            this.data.splice(index, 1);
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
      });
    }
  }
};
</script>


<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// src/components/views/skip/skipList.vue